/** sessionStorage usado por SolicitacaoVisitaView (consumirPrefillDaAgenda). */
export const STORAGE_PREFILL_VISITANTE = "acesso_prefill_visitante";

/**
 * Pré-preenche o cadastro de nova visita (rota /solicitacao-visita/novo ou modal na agenda).
 * @param {object} payload — nomeCompleto, documentoRgCnh, email, telefoneWhatsapp, visitanteId opcional
 */
export function gravarPrefillVisitanteNovaVisita(payload) {
  try {
    sessionStorage.setItem(STORAGE_PREFILL_VISITANTE, JSON.stringify(payload || {}));
  } catch (_) {
    /* ignore */
  }
}
